import {
  jb_simple_page_hero_css_default
} from "./chunk.V7RTSXLH.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-simple-page-hero/jb-simple-page-hero.ts
var JbSimplePageHero = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 10, type: "no-vertical-space" };
  }
  render() {
    return b`<jb-heading
      rank="1"
      variant="heading-lg"
      ><slot></slot
    ></jb-heading>`;
  }
};
JbSimplePageHero.styles = [reset_css_default, jb_simple_page_hero_css_default];
JbSimplePageHero = __decorateClass([
  customElement("jb-simple-page-hero")
], JbSimplePageHero);

export {
  JbSimplePageHero
};
